import { FieldDefinition } from '../dynamic-forms/field-definition';
import { ColumnDefinition } from '../dynamic-grids/column-definition';
import { ButtonDefinition } from '../buttons/button-definition';

export class PageHeaderBarConfig {
    title: string;
    buttonDefinition: Array<ButtonDefinition>;

    constructor() {

    }
}

export class PageSubheaderBarConfig {
    title: string;
    buttonDefinition: Array<ButtonDefinition>;

    constructor() {

    }
}

export class PageSearchableListConfig {
    filterDefinition: Array<FieldDefinition>;
    columnDefinition: Array<ColumnDefinition>;
    pageSubheaderBarConfig: PageSubheaderBarConfig;
    getListApi: string;

    constructor() {

    }
}

export class PageListConfig {
    columnDefinition: Array<ColumnDefinition>;
    pageHeaderBarConfig: PageHeaderBarConfig;
    rowKey: string;

    constructor() {

    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/pages/page-config-api.ts